import { AnimatedAccordion } from '@components/primitives/AnimatedAccordion'
import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faBallotCheck } from '@fortawesome/pro-regular-svg-icons/faBallotCheck'
import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { faFaceThermometer } from '@fortawesome/pro-regular-svg-icons/faFaceThermometer'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'

import { useState } from 'react'

export const TrialFaqAccordions = ({
  conjuredFaq,
  hideCheckEligibilityLink,
  hideStudyDesignLink,
}: {
  conjuredFaq: {
    potentialSideEffects: string | null
    whatIsBeingTested: string | null
    whoIsTrialFor: string | null
  }
  hideCheckEligibilityLink?: boolean
  hideStudyDesignLink?: boolean
}) => {
  return (
    <div className='flex flex-col gap-2'>
      {conjuredFaq.whoIsTrialFor && (
        <TrialFaqAccordion
          ctaLink={'#eligibilityCriteria'}
          ctaText={hideCheckEligibilityLink ? '' : 'Check my eligibility'}
          icon={faBallotCheck}
          text={conjuredFaq.whoIsTrialFor}
          title='Who is the study for?'
        />
      )}
      {conjuredFaq.whatIsBeingTested && (
        <TrialFaqAccordion
          ctaLink={'#trialDesign'}
          ctaText={hideStudyDesignLink ? '' : 'See study design'}
          icon={faCapsules}
          text={conjuredFaq.whatIsBeingTested}
          title='What is being tested?'
        />
      )}
      {conjuredFaq.potentialSideEffects && (
        <TrialFaqAccordion
          icon={faFaceThermometer}
          text={conjuredFaq.potentialSideEffects}
          title='What are the potential side effects?'
        />
      )}
    </div>
  )
}

const TrialFaqAccordion = ({
  ctaLink,
  ctaText,
  icon,
  text,
  title,
}: {
  ctaLink?: string
  ctaText?: string
  icon: IconDefinition
  text: string
  title: string
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <div
      className='flex cursor-pointer flex-col rounded-lg border border-neutral200 bg-neutral50 p-4'
      onClick={() => {
        setIsExpanded(!isExpanded)
        trackEvent(TrackingEvents.FAQ_CONJURED_FAQ_CLICKED, { val: title })
      }}
    >
      <div className='flex items-center justify-between'>
        <Text className='inline' styleName='p-small-strong'>
          <Icon className='mr-2' icon={icon} />
          {title}
        </Text>
        <Icon
          className={`transform transition-all duration-500 ${
            isExpanded ? 'rotate-90' : ''
          }`}
          icon={faAngleRight}
          size='lg'
        />
      </div>
      <AnimatedAccordion isExpanded={isExpanded}>
        <Text className='mt-2 text-neutral600' styleName='p-small'>
          {text}
        </Text>
        {ctaText && (
          <a href={ctaLink} onClick={(e) => e.stopPropagation()}>
            <Text className='mt-2 underline' styleName='p-small-strong'>
              {ctaText}
              <Icon className='ml-2' icon={faArrowRight} />
            </Text>
          </a>
        )}
      </AnimatedAccordion>
    </div>
  )
}
